export const MASTER_NAME = 'AS Services'
export const EXPERIENCE = '10+ years'